import videoTelephone from '../../videos/telefonieren.mp4'
import videoInternet from '../../videos/internet.mp4'
import videoMusic from '../../videos/musik.mp4'
import videoTV from '../../videos/tv.mp4'
import videoSocialmedia from '../../videos/socialmedia.mp4'
import ExplainMe from 'components/ExplainMe'
import { Stink } from 'components/Stink'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import StorageEvolution from 'components/StorageEvolution'
import DownloadComparison from 'components/DownloadComparison'
import imageNokia from '../../images/nokia3210.png'
import imageHandy from '../../images/handy.png'
import imageTaxcard from '../../images/taxcard.png'
import imageSnake from '../../images/snake.gif'
import imageBluewindow from '../../images/blue-window.jpg'
import imagePublifon from '../../images/publifon.jpg'
import imageWalkman from '../../images/walkman.jpg'
import imageDiscman from '../../images/discman.png'
import imageMyspace from '../../images/myspace.jpg'
import imageStudivz from '../../images/studivz.jpg'
import imageIcq from '../../images/icq.jpg'
import audioIcq from '../../audio/icq.mp3'
import imageVhs from '../../images/vhs.gif'
import videoTeleclub from '../../videos/teleclub.mp4'
import audioModem from '../../audio/modem.mp3'

export const sectionsDE = (birthYear: number, appRef: any) => {
  const calculateAge = (year: number) => {
    return year - birthYear
  }

  return {
    telephone: {
      id: 'telephone',
      title: 'Wie wir<br />telefonieren',
      titleMobile: 'Wie wir<br />telefonieren',
      video: videoTelephone,
      source: 'Videomaterial: SRF Archiv',
      license: '© 1970-2018 SRF, lizenziert durch Telepool GmbH Zürich',
      intro: (
        <p className='intro'>
          1993 waren Mobiltelefone auf der Strasse noch ein Hingucker, nur
          sieben Jahre später besass bereits die Mehrheit der Schweizerinnen und
          Schweizer ein Gerät.
        </p>
      ),
      content: [
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/SFuQJ/22/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'personalized',
          text: [
            {
              from: 0,
              to: 1959,
              title: 'Handy? Damit haben Sie abgewaschen',
              txt: (
                <>
                  <p>
                    Als mobiles Telefonieren 1975 erstmals Thema in der Schweiz
                    wurde, waren Sie bereits erwachsen – und die Migros
                    verkaufte schon über eine Dekade lang Spülmittel unter dem
                    Namen{' '}
                    <ExplainMe
                      term='«Handy»'
                      image={imageHandy}
                      appRef={appRef}
                    />
                    . Als die Swisscom 1993 das 2G-Netz einführte und sich
                    gerade mal 262’000 SIM-Karten im Umlauf befanden, waren Sie{' '}
                    {calculateAge(1993)} Jahre alt. Knapp sieben Jahre später,
                    als Sie {calculateAge(1999)} waren, telefonierte schon mehr
                    als die Hälfte der Bevölkerung mobil, Verkaufshit war das
                    kultige{' '}
                    <ExplainMe
                      term='Nokia 3210'
                      image={imageNokia}
                      caption='Das Nokia 3210 war das erste kommerziell erfolgreiche Handy ohne externe Antenne. Insgesamt wurden 160 Millionen Geräte verkauft.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />
                  </p>
                  <p>
                    2007 läutete das iPhone eine neue Zeitrechnung ein. War die
                    Devise bis dahin «Klein, kleiner, am besten», wechselte der
                    Trend: Die Natels – wie es in der Schweiz dank der Swisscom
                    und ihrem «Nationalen AutoTELefon» heisst – wurden wieder
                    grösser und vor allem «smarter». Sie erhielten Touchscreens,
                    Internetzugang und immer bessere (und immer mehr) Kameras.
                    Inzwischen ist die Schweiz fest im Griff des Smartphones:
                    2022 hatten gut 93 Prozent der Bevölkerung eins. Sie sind
                    mit grosser Wahrscheinlichkeit auch smart unterwegs. Bei den
                    12- bis 19-Jährigen lag die Zahl der Smartphone-Benutzer
                    2022{' '}
                    <Stink href='https://www.zhaw.ch/storage/psychologie/upload/forschung/medienpsychologie/james/2018/Bericht_JAMES_2022_de.pdf'>
                      gemäss der James-Studie
                    </Stink>{' '}
                    bei 99 Prozent.
                  </p>
                </>
              ),
            },
            {
              from: 1960,
              to: 1979,
              title: 'Wow – Sie wissen, was Natel wirklich heisst',
              txt: (
                <>
                  <p>
                    Sie konnten die rasante technische Entwicklung im Mobilfunk
                    von Beginn an erleben – und wissen dennoch auch, was eine{' '}
                    <ExplainMe
                      term='Taxcard'
                      image={imageTaxcard}
                      caption='Die schweizerische Bezeichnung für Telefonkarte ist Taxcard. Sie wurde 1981 eingeführt und diente zum bargeldlosen Bezahlen in öffentlichen Telefonzellen. Die Taxcards der Standardserien gab es zu 5, 10 und 20 Schweizer Franken.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />{' '}
                    ist. Bei der Einführung der ersten Handys ohne sichtbare
                    Antenne 1999 waren Sie schon {calculateAge(1999)} Jahre alt,
                    und schon mehr als die Hälfte der Bevölkerung telefonierte
                    mobil. Wahrscheinlich haben Sie schon mal auf einem Nokia
                    3210{' '}
                    <ExplainMe
                      term='«Snake»'
                      image={imageSnake}
                      caption='Snake ist ein Computerspielklassiker, bei dem eine Schlange rechtwinklig über ein Spielfeld gesteuert wird. Ziel ist es, die als Futter angebotenen, zufällig erscheinenden «Happen» aufzunehmen und Hindernissen, einschliesslich des eigenen Schlangenkörpers, auszuweichen. Während die Schlange mit jedem Happen wächst, wird das Manövrieren immer schwieriger.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />{' '}
                    gespielt. Sollte es wirklich eine Generation geben, die
                    weiss, wofür Natel eigentlich steht, ist es Ihre: Das
                    «Nationale AutoTELefon» wurde 1978 von den PTT, der heutigen
                    Swisscom, lanciert.
                  </p>{' '}
                  <p>
                    2007 läutete das iPhone eine neue Zeitrechnung ein. War die
                    Devise bis dahin «Klein, kleiner, am besten», wechselte der
                    Trend: Die Natels wurden wieder grösser und vor allem
                    «smarter». Sie erhielten Touchscreens, Internetzugang und
                    immer bessere (und immer mehr) Kameras. Inzwischen ist die
                    Schweiz fest im Griff des Smartphones: 2022 hatten gut 93
                    Prozent der Bevölkerung eins. Sie sind mit Sicherheit auch
                    smart unterwegs. Bei den 12- bis 19-Jährigen lag die Zahl
                    der Smartphone-Benutzer 2022{' '}
                    <Stink href='https://www.zhaw.ch/storage/psychologie/upload/forschung/medienpsychologie/james/2018/Bericht_JAMES_2022_de.pdf'>
                      gemäss der James-Studie
                    </Stink>{' '}
                    bei 99 Prozent.
                  </p>
                </>
              ),
            },
            {
              from: 1980,
              to: 1985,
              title: 'Glückwunsch – Sie gehören zur ersten mobilen Generation',
              txt: (
                <>
                  <p>
                    Als sich 1993 die ersten 262’000 SIM-Karten im Umlauf
                    befanden, waren Sie erst {calculateAge(1993)} Jahre alt. Mit{' '}
                    {calculateAge(1999)} Jahren haben Sie mit hoher
                    Wahrscheinlichkeit schon auf einem Nokia 3210{' '}
                    <ExplainMe
                      term='«Snake»'
                      image={imageSnake}
                      caption='Snake ist ein Computerspielklassiker, bei dem eine Schlange rechtwinklig über ein Spielfeld gesteuert wird. Ziel ist es, die als Futter angebotenen, zufällig erscheinenden «Happen» aufzunehmen und Hindernissen, einschliesslich des eigenen Schlangenkörpers, auszuweichen. Während die Schlange mit jedem Happen wächst, wird das Manövrieren immer schwieriger.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />{' '}
                    gespielt: 1999 telefonierte schon die Hälfte der Bevölkerung
                    mobil. Sie wissen, dass T9 nicht die neunte Fortsetzung des
                    Filmklassikers «Terminator» ist, sondern die erste
                    Schreibhilfe für das Mobiltelefon – und Sie haben mit
                    Schrecken den Niedergang von Nokia miterlebt.
                  </p>
                  <p>
                    Sie waren {calculateAge(2007)} Jahre alt, als 2007 das
                    iPhone eine neue Zeitrechnung einläutete. War die Devise bis
                    dahin «Klein, kleiner, am besten», wechselte der Trend: Die
                    Natels wurden wieder grösser und vor allem «smarter».
                    Tastaturen und Knöpfe verschwanden. Es kamen Touchscreens,
                    Internetzugang und immer bessere (und immer mehr) Kameras.
                    Inzwischen ist die Schweiz fest im Griff des Smartphones:
                    2022 hatten gut 93 Prozent der Bevölkerung eins. Sie sind
                    mit Sicherheit auch smart unterwegs. Bei den 12- bis
                    19-Jährigen lag die Zahl der Smartphone-Benutzer 2022{' '}
                    <Stink href='https://www.zhaw.ch/storage/psychologie/upload/forschung/medienpsychologie/james/2018/Bericht_JAMES_2022_de.pdf'>
                      gemäss der James-Studie
                    </Stink>{' '}
                    bei 99 Prozent.
                  </p>
                  <p>
                    Sie sind mit Mobiltelefonen gross geworden und müssen sich
                    heute trotzdem von Kindern die neuesten Apps und Trends
                    zeigen lassen. Wahrscheinlich wünschen Sie sich manchmal
                    insgeheim eine Digital-Detox-Kur. Keine Angst, wir verraten
                    es keinem.
                  </p>
                </>
              ),
            },
            {
              from: 1986,
              to: 1999,
              title: 'Ein Leben ohne Handy kennen Sie nicht',
              txt: (
                <>
                  <p>
                    Sie waren erst {calculateAge(2000)}-jährig, als schon
                    deutlich mehr als die Hälfte der Schweizer Bevölkerung ein
                    Mobiltelefon besass, und {calculateAge(2002)} Jahre alt, als
                    Handys zu Fotokameras wurden. Wenn Sie nicht auf dem eigenen
                    Mobiltelefon{' '}
                    <ExplainMe
                      term='«Snake»'
                      image={imageSnake}
                      caption='Snake ist ein Computerspielklassiker, bei dem eine Schlange rechtwinklig über ein Spielfeld gesteuert wird. Ziel ist es, die als Futter angebotenen, zufällig erscheinenden «Happen» aufzunehmen und Hindernissen, einschliesslich des eigenen Schlangenkörpers, auszuweichen. Während die Schlange mit jedem Happen wächst, wird das Manövrieren immer schwieriger.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />{' '}
                    gespielt haben, dann mindestens auf dem Ihrer Eltern – und
                    manchmal durften Sie mit dem Nokia 3210 Oma eine SMS
                    schreiben.
                  </p>
                  <p>
                    Vor Ihren Augen wurden die grossen Handys zuerst immer
                    kleiner und dann plötzlich wieder gross. Sie waren{' '}
                    {calculateAge(2007)} Jahre alt, als 2007 das iPhone eine
                    neue Zeitrechnung einläutete. Die Handys erhielten
                    Touchscreens, Internetzugang und immer bessere (und immer
                    mehr) Kameras. Inzwischen ist die Schweiz fest im Griff des
                    Smartphones: 2022 hatten gut 93 Prozent der Bevölkerung
                    eins. Heute sind Sie mit Sicherheit smart unterwegs.
                  </p>
                </>
              ),
            },
            {
              from: 2000,
              to: 2007,
              title:
                'Es ist wahr – Handys hatten früher Tasten, ausziehbare Antennen und keine Kameras',
              txt: (
                <>
                  <p>
                    Wow, Sie kennen das Klicken physischer Handytastaturen nur
                    von Ihren Eltern, wenn überhaupt. Als ab 2002 immer mehr
                    Mobiltelefone zu Fotokameras wurden,{' '}
                    {birthYear < 2003
                      ? 'steckten Sie noch in den Windeln'
                      : 'waren Sie noch nicht mal geboren'}
                    . Ihr erstes Mobiltelefon war ein Smartphone. Sie haben es
                    immer dabei und nehmen es natürlich auch mit ins Bett.
                  </p>
                </>
              ),
            },
            {
              from: 2008,
              to: 3000,
              title:
                'Es ist wahr – Handys hatten früher Tasten, ausziehbare Antennen und keine Kameras',
              txt: (
                <>
                  <p>
                    Wow, Sie kennen das Klicken physischer Handytastaturen nur
                    von Erzählungen ihrer Eltern. Als ab 2002 immer mehr
                    Mobiltelefone zu Fotokameras wurden, waren Sie noch nicht
                    mal geboren. Ihr erstes Mobiltelefon – wenn Sie überhaupt
                    schon eines besitzen – war ein Smartphone. Sie haben es
                    immer dabei und nehmen es natürlich auch mit ins Bett.
                  </p>
                </>
              ),
            },
          ],
        },
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/rR3yf/11/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'personalized',
          text: [
            {
              from: 0,
              to: 1959,
              title: 'Aufstieg und Niedergang',
              txt: (
                <p>
                  Seit 2002, da waren Sie bereits {calculateAge(2002)} Jahre
                  alt, sinkt die Zahl der Festnetzanschlüsse in der Schweiz –
                  der Niedergang der Telefonkabine setzte bereits vorher ein.
                  Was Sie dennoch kaum wissen dürften: Das erste öffentliche
                  Telefon wurde bereits 1881 bei der Fraumünsterpost in Zürich
                  installiert. 1997 – auf dem Höhepunkt – gab es in der Schweiz
                  61’220{' '}
                  <ExplainMe
                    term='Publifone'
                    image={imagePublifon}
                    maxWidth={640}
                    caption='Die letzte von der Swisscom betriebene Telefonkabine (Publifon) wurde im November 2019 in Baden demontiert.'
                    source='Foto: Walter Bieri (Keystone)'
                    appRef={appRef}
                  />
                  , danach ging es steil bergab: Zwischen 2004 und 2016 sank die
                  Zahl der Gespräche um 95 Prozent. Drei Jahre später
                  demontierte die Swisscom die letzte öffentliche Telefonkabine.
                  Einzig im Auftrag von Spitälern, Restaurants, Schulen oder
                  Privaten werden Telefonkabinen auch weiterhin betrieben. Zudem
                  sind in Schweizer Städten 115 runde Glaskabinen – sogenannte
                  «Telecabs 2000» – zu finden. Diese werden vom Werbeunternehmen
                  APG/SGA finanziert, ausgehende Anrufe ins Schweizer Fest- und
                  Mobilfunknetz sind sogar gratis. Rund 650 Publifone wurden
                  umgenutzt. Sie dienen nun als Getränke- oder Snackautomaten,
                  als Standorte für Defibrillatoren, Bücherschränke oder Bars.
                </p>
              ),
            },
            {
              from: 1960,
              to: 1974,
              title: 'Streiche aus der Telefonzelle',
              txt: (
                <p>
                  Sie haben gute Erinnerungen ans Festnetztelefon, genauso wie
                  an die Telefonkabine: Auch mal den Lehrer aus der Zelle
                  angerufen und gleich wieder aufgehängt? Oder sehnsüchtig aus
                  den Ferien dem Schatz ins Ohr gesäuselt? Vielleicht sogar mit
                  einer{' '}
                  <ExplainMe
                    term='Taxcard'
                    image={imageTaxcard}
                    caption='Die schweizerische Bezeichnung für Telefonkarte ist Taxcard. Sie wurde 1981 eingeführt und diente zum bargeldlosen Bezahlen in öffentlichen Telefonzellen. Die Taxcards der Standardserien gab es zu 5, 10 und 20 Schweizer Franken.'
                    source='Quelle: Wikipedia'
                    appRef={appRef}
                  />
                  , die 1981 eingeführt wurde und treuer Begleiter bei
                  Auslandaufenthalten war? 1997 – da waren Sie{' '}
                  {calculateAge(1997)} Jahre alt – gab es in der Schweiz 61’220
                  Publifone. Heute ist das{' '}
                  <ExplainMe
                    term='Publifon'
                    image={imagePublifon}
                    maxWidth={640}
                    caption='Die letzte von der Swisscom betriebene Telefonkabine (Publifon) wurde im November 2019 in Baden demontiert.'
                    source='Foto: Walter Bieri (Keystone)'
                    appRef={appRef}
                  />{' '}
                  Geschichte: Zwischen 2004 und 2016 sank die Zahl der Gespräche
                  um 95 Prozent. Drei Jahre später demontierte die Swisscom die
                  letzte öffentliche Telefonkabine. Einzig im Auftrag von
                  Spitälern, Restaurants, Schulen oder Privaten werden
                  Telefonkabinen auch weiterhin betrieben. Zudem sind in
                  Schweizer Städten 115 runde Glaskabinen – sogenannte «Telecabs
                  2000» – zu finden. Diese werden vom Werbeunternehmen APG/SGA
                  finanziert, ausgehende Anrufe ins Schweizer Fest- und
                  Mobilfunknetz sind sogar gratis. Rund 650 Publifone wurden
                  umgenutzt. Sie dienen nun als Getränke- oder Snackautomaten,
                  als Standorte für Defibrillatoren, Bücherschränke oder Bars.
                </p>
              ),
            },
            {
              from: 1975,
              to: 1985,
              title: 'Eine Taxcard, bitte!',
              txt: (
                <>
                  <p>
                    Sie haben die Blütezeit der Telefonkabine erlebt. 1997 – da
                    waren Sie {calculateAge(1997)} Jahre alt – gab es in der
                    Schweiz 61’220{' '}
                    <ExplainMe
                      term='Publifone'
                      image={imagePublifon}
                      maxWidth={640}
                      caption='Die letzte von der Swisscom betriebene Telefonkabine (Publifon) wurde im November 2019 in Baden demontiert.'
                      source='Foto: Walter Bieri (Keystone)'
                      appRef={appRef}
                    />
                    . Wahrscheinlich besassen Sie sogar eine{' '}
                    <ExplainMe
                      term='Taxcard'
                      image={imageTaxcard}
                      caption='Die schweizerische Bezeichnung für Telefonkarte ist Taxcard. Sie wurde 1981 eingeführt und diente zum bargeldlosen Bezahlen in öffentlichen Telefonzellen. Die Taxcards der Standardserien gab es zu 5, 10 und 20 Schweizer Franken.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />
                    . Bestimmt haben Sie sich über Raucher geärgert, die vor
                    Ihnen in der Kabine waren, und wahrscheinlich auch mal über
                    die Schlange hinter Ihnen, wenn Sie gerade ein etwas
                    längeres Gespräch führen wollten. Tja, das ist Geschichte:
                    Zwischen 2004 und 2016 sank die Zahl der Gespräche um 95
                    Prozent. Drei Jahre später demontierte die Swisscom die
                    letzte öffentliche Telefonkabine. Einzig im Auftrag von
                    Spitälern, Restaurants, Schulen oder Privaten werden
                    Telefonkabinen auch weiterhin betrieben. Zudem sind in
                    Schweizer Städten 115 runde Glaskabinen – sogenannte
                    «Telecabs 2000» – zu finden. Diese werden vom
                    Werbeunternehmen APG/SGA finanziert, ausgehende Anrufe ins
                    Schweizer Fest- und Mobilfunknetz sind sogar gratis. Rund
                    650 Publifone wurden umgenutzt. Sie dienen nun als Getränke-
                    oder Snackautomaten, als Standorte für Defibrillatoren,
                    Bücherschränke oder Bars.
                  </p>
                </>
              ),
            },
            {
              from: 1986,
              to: 1999,
              title: 'Es war einmal…',
              txt: (
                <>
                  <p>
                    Die Blütezeit der Telefonkabinen haben Sie nicht bewusst
                    erlebt. Auf dem Höhepunkt 1997 – da waren Sie{' '}
                    {birthYear < 1998
                      ? 'ein Kind'
                      : 'noch nicht mal auf der Welt'}{' '}
                    – gab es in der Schweiz 61’220{' '}
                    <ExplainMe
                      term='Publifone'
                      image={imagePublifon}
                      maxWidth={640}
                      caption='Die letzte von der Swisscom betriebene Telefonkabine (Publifon) wurde im November 2019 in Baden demontiert.'
                      source='Foto: Walter Bieri (Keystone)'
                      appRef={appRef}
                    />
                    . Danach ging es rasant bergab, kaum jemand hat die
                    Telefonzellen noch genutzt: Zwischen 2004 und 2016 sank die
                    Zahl der Gespräche um 95 Prozent. Drei Jahre später
                    demontierte die Swisscom die letzte öffentliche
                    Telefonkabine. Einzig im Auftrag von Spitälern, Restaurants,
                    Schulen oder Privaten werden Telefonkabinen auch weiterhin
                    betrieben. Zudem sind in Schweizer Städten 115 runde
                    Glaskabinen – sogenannte «Telecabs 2000» – zu finden. Diese
                    werden vom Werbeunternehmen APG/SGA finanziert, ausgehende
                    Anrufe ins Schweizer Fest- und Mobilfunknetz sind sogar
                    gratis. Rund 650 Publifone wurden umgenutzt. Sie dienen nun
                    als Getränke- oder Snackautomaten, als Standorte für
                    Defibrillatoren, Bücherschränke oder Bars.
                  </p>
                </>
              ),
            },
            {
              from: 2000,
              to: 3000,
              title: 'Es war einmal…',
              txt: (
                <>
                  <p>
                    Festnetz,{' '}
                    <ExplainMe
                      term='Telefonkabine'
                      image={imagePublifon}
                      maxWidth={640}
                      caption='Die letzte von der Swisscom betriebene Telefonkabine (Publifon) wurde im November 2019 in Baden demontiert.'
                      source='Foto: Walter Bieri (Keystone)'
                      appRef={appRef}
                    />
                    ,{' '}
                    <ExplainMe
                      term='Taxcard'
                      image={imageTaxcard}
                      caption='Die schweizerische Bezeichnung für Telefonkarte ist Taxcard. Sie wurde 1981 eingeführt und diente zum bargeldlosen Bezahlen in öffentlichen Telefonzellen. Die Taxcards der Standardserien gab es zu 5, 10 und 20 Schweizer Franken.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />{' '}
                    – all diese Begriffe klingen für Sie wie Fabelwesen aus
                    einer anderen Welt. Aber das jetzt nochmals aufzurollen,
                    wäre zu viel des Guten.
                  </p>
                </>
              ),
            },
          ],
        },
      ],
    },
    internet: {
      id: 'internet',
      title: 'Wie wir<br />online gehen',
      titleMobile: 'Wie wir<br />online gehen',
      video: videoInternet,
      source: 'Videomaterial: SRF Archiv',
      license: '© 1970-2018 SRF, lizenziert durch Telepool GmbH Zürich',
      intro: (
        <p className='intro'>
          Nachdem das Internet gut zwanzig Jahre lang nur Universitäten und
          Forschungseinrichtungen vernetzte, war es ab 1990 öffentlich
          zugänglich. Danach dauerte es nur wenige Jahre, bis die Mehrheit der
          Schweizerinnen und Schweizer online war.
        </p>
      ),
      content: [
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '540px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/vss4o/12/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'personalized',
          text: [
            {
              from: 0,
              to: 1949,
              title:
                'Wow – Sie haben die Mehrheit Ihres Leben ohne Internet verbracht',
              txt: (
                <>
                  <p>
                    Sie waren schon {calculateAge(1991)} Jahre alt, als 1991 die
                    ersten Webserver ausserhalb der Forschungseinrichtung Cern
                    den Betrieb aufnahmen. Vier Jahre später begannen die ersten
                    paar Tausend Schweizer, mehrmals wöchentlich im Internet zu
                    surfen. Die technischen Hürden wurden immer kleiner: 1996
                    lieferte{' '}
                    <ExplainMe
                      term='«theblue window»'
                      image={imageBluewindow}
                      maxWidth={640}
                      caption='1996 präsentierten die damalige PTT (heute Swisscom) und die Multimedia Application Center AG zusammen «the blue window». Als erster Schweizer Anbieter ermöglichte das Portal, sich zum Ortstarif ins Internet einzuwählen.'
                      source='Foto: Keystone'
                      appRef={appRef}
                    />{' '}
                    alle für das Internet nötigen Programme auf einer CD. Als
                    Sie {calculateAge(2003)} Jahre alt waren, nutzte schon die
                    Hälfte der Schweizer das Internet regelmässig. Zumindest in
                    den eigenen vier Wänden und im Büro, denn das mobile
                    Internet liess noch ein paar Jahre auf sich warten.
                  </p>
                  <p>
                    Erst mit Verkaufsstart des ersten iPhones in der Schweiz
                    2008 – Sie waren da bereits {calculateAge(2008)} Jahre alt –
                    und dem Aufkommen von Daten-Abos begann das rasante Wachstum
                    der mobilen Internetzugänge: Surften 2008 gerade mal 7
                    Prozent unterwegs, waren es zehn Jahre später bereits 46
                    Prozent. Heute ist fast die ganze Schweiz online: 96 Prozent
                    nutzen das Internet regelmässig – die meisten davon täglich.
                  </p>
                </>
              ),
            },
            {
              from: 1950,
              to: 1970,
              title: 'Glückwunsch – Sie haben eine Welt ohne Internet erlebt',
              txt: (
                <>
                  <p>
                    Das Geräusch, das Sie hörten, als Sie Post erhielten, war
                    höchstens ein quietschender Briefkasten oder die Türklingel
                    und kein digitales «Pling». Sie waren {calculateAge(1995)}{' '}
                    Jahre alt, als ab Mitte der 90er-Jahre die ersten paar
                    Tausend Schweizer mehrmals pro Woche im Internet surften –
                    natürlich mit dem{' '}
                    <ExplainMe
                      term='Netscape Navigator'
                      image={imageBluewindow}
                      maxWidth={640}
                      caption='Netscape Navigator war ein Webbrowser, der vom Unternehmen Netscape Communications entwickelt wurde. 2008 stellte es Weiterentwicklung und Support für Netscape ein.'
                      source='Foto: Keystone'
                      appRef={appRef}
                    />
                    . In den folgenden Jahren mussten Sie sich mit langsamen
                    Übertragungsgeschwindigkeiten und horrenden Preisen
                    herumschlagen: Eine Verbindung über das Telefonnetz konnte
                    bis zu 25 Rappen pro Minute kosten. Bei einer täglichen
                    Nutzung von einer Stunde wuchs die Rechnung pro Monat auf
                    fast 500 Franken. Erst als sich das Tempo des Internets
                    erhöhte, die Kosten sanken und Sie
                    {calculateAge(2003)} Jahre alt waren, war 2003 eine Mehrheit
                    der Bevölkerung regelmässig online.
                  </p>
                  <p>
                    Die Nutzung des mobilen Internets in der Schweiz liess aber
                    noch ein paar Jahre auf sich warten. Erst mit Verkaufsstart
                    des ersten iPhones in der Schweiz 2008 – Sie waren da{' '}
                    {calculateAge(2008)} Jahre alt – und dem Aufkommen von
                    Daten-Abos begann die zweite Revolution: Surften 2008 gerade
                    mal 7 Prozent unterwegs, waren es zehn Jahre später bereits
                    46 Prozent. Heute ist fast die ganze Schweiz online: 96
                    Prozent nutzen das Internet regelmässig – die meisten davon
                    täglich.
                  </p>
                </>
              ),
            },
            {
              from: 1971,
              to: 1980,
              title:
                'Ihre Kindheit und Jugend haben Sie ohne Internet verbracht',
              txt: (
                <>
                  <p>
                    Danach ging es aber los. Sie waren {calculateAge(1995)}, als
                    ab Mitte der 90er-Jahre die ersten paar Tausend Schweizer
                    mehrmals pro Woche im Internet surften – natürlich mit dem{' '}
                    <ExplainMe
                      term='Netscape Navigator'
                      image={imageBluewindow}
                      maxWidth={640}
                      caption='Netscape Navigator war ein Webbrowser, der von dem Unternehmen Netscape Communications entwickelt wurde. 2008 stellte es Weiterentwicklung und Support für Netscape ein.'
                      source='Foto: Keystone'
                      appRef={appRef}
                    />
                    . In den folgenden Jahren mussten Sie sich mit langsamen
                    Übertragungsgeschwindigkeiten und horrenden Preisen
                    herumschlagen: Eine Verbindung über das Telefonnetz konnte
                    bis zu 25 Rappen pro Minute kosten. Bei einer täglichen
                    Nutzung von einer Stunde wuchs die Rechnung pro Monat auf
                    fast 500 Franken. Erst als sich das Tempo des Internets
                    erhöhte, die Kosten sanken und Sie {calculateAge(2003)}{' '}
                    Jahre alt waren, war 2003 eine Mehrheit der Bevölkerung
                    regelmässig online.
                  </p>
                  <p>
                    Die Nutzung des mobilen Internets in der Schweiz liess aber
                    noch ein paar Jahre auf sich warten. Erst mit Verkaufsstart
                    des ersten iPhones in der Schweiz 2008 – Sie waren da{' '}
                    {calculateAge(2008)} Jahre alt – und dem Aufkommen von
                    Daten-Abos begann die zweite Revolution: Surften 2008 gerade
                    mal 7 Prozent unterwegs, waren es zehn Jahre später bereits
                    46 Prozent. Heute ist fast die ganze Schweiz online: 96
                    Prozent nutzen das Internet regelmässig – die meisten davon
                    täglich.
                  </p>
                </>
              ),
            },
            {
              from: 1981,
              to: 1999,
              title: 'Chrrrzzzssssttt',
              txt: (
                <>
                  <p>
                    An das{' '}
                    <ExplainMe
                      term='Einwahl-Krächzen'
                      audio={audioModem}
                      maxWidth={320}
                      caption='Typische Geräusche eines Einwahlmodems, während dem Verbindungsaufbau mit einem lokalen ISP-Server, um Zugang zum Internet zu erhalten.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />{' '}
                    des Modems erinnern Sie sich womöglich noch knapp. Für Sie
                    war das Internet fast von Beginn weg da. Als das Onlinetempo
                    schneller wurde, die Kosten sanken und Sie erst{' '}
                    {calculateAge(2003)} Jahre alt waren, surfte 2003 schon eine
                    Mehrheit der Bevölkerung regelmässig im Internet, und die
                    Anzahl der registrierten .ch-Adressen stieg auf eine halbe
                    Million.
                  </p>
                  <p>
                    Die Nutzung des mobilen Internets in der Schweiz liess aber
                    noch ein paar Jahre auf sich warten. Erst mit Verkaufsstart
                    des ersten iPhones in der Schweiz 2008 – Sie waren da{' '}
                    {calculateAge(2008)} Jahre alt – und dem Aufkommen von
                    Daten-Abos begann die zweite Revolution: Surften 2008 gerade
                    mal 7 Prozent unterwegs, waren es zehn Jahre später bereits
                    46 Prozent. Heute ist fast die ganze Schweiz online: 96
                    Prozent nutzen das Internet regelmässig – die meisten davon
                    täglich.
                  </p>
                </>
              ),
            },
            {
              from: 2000,
              to: 3000,
              title: 'Wow, eine Welt ohne Internet kennen Sie nicht',
              txt: (
                <>
                  <p>
                    Sie sind {birthYear > 2001 ? 'jünger ' : 'gleich alt '} wie
                    Wikipedia und mussten garantiert nie etwas in den gut 20
                    Bänden der Brockhaus-Enzyklopädie nachschlagen.{' '}
                    {birthYear < 2004
                      ? birthYear < 2003
                        ? 'Als Sie Ihren ' +
                          calculateAge(2003) +
                          '. Geburtstag feierten, '
                        : 'Als Sie geboren wurden, '
                      : '2003 – also noch vor Ihrer Geburt – '}
                    surfte bereits jeder zweite Schweizer mehrmals pro Woche im
                    Internet. Die Nutzung des mobilen Internets in der Schweiz
                    liess aber noch ein paar Jahre auf sich warten. Erst mit
                    Verkaufsstart des ersten iPhones in der Schweiz 2008 –{' '}
                    {birthYear < 2008
                      ? 'Sie waren da gerade mal ' +
                        calculateAge(2008) +
                        '-jährig '
                      : 'auch das geschah vor Ihrer Zeit '}
                    – und dem Aufkommen von Daten-Abos begann die zweite
                    Revolution: Surften 2008 gerade mal 7 Prozent unterwegs,
                    waren es zehn Jahre später bereits 46 Prozent.
                  </p>
                  <p>
                    Heute ist fast die ganze Schweiz online: 96 Prozent nutzen
                    das Internet regelmässig – die meisten davon täglich.
                  </p>
                </>
              ),
            },
          ],
        },
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/9S0bM/6/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'general',
          text: (
            <div>
              <DownloadComparison />
            </div>
          ),
        },
      ],
    },
    music: {
      id: 'music',
      title: 'Wie wir<br />Musik hören',
      titleMobile: 'Wie wir<br />Musik hören',
      video: videoMusic,
      source: 'Videomaterial: SRF Archiv',
      license: '© 1970-2018 SRF, lizenziert durch Telepool GmbH Zürich',
      intro: (
        <p className='intro'>
          Der physische Tonträger ist praktisch tot. Im Jahr 2000 gingen in der
          Schweiz 19,6 Millionen CDs über den Ladentisch, heute sind es nur noch
          0,63 Millionen. Dass Schallplatten (LPs) seit 2014 ein kleines Revival
          erleben, hebt die Laune der Musikbranche nicht wirklich.
        </p>
      ),
      content: [
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/TsHRU/13/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'personalized',
          text: [
            {
              from: 0,
              to: 1949,
              title: 'Knister, knister',
              txt: (
                <p>
                  Sie sind älter als das erste tragbare Radio (Sony TR-63,
                  Baujahr 1957). Musik haben Sie vor allem zu Hause genossen, im
                  Radio oder vom Plattenspieler. Als 1979 das Hören mit dem{' '}
                  <ExplainMe
                    term='Walkman'
                    image={imageWalkman}
                    maxWidth={480}
                    caption="Der TPS-L2 war der erste portable Kassettenspieler und wurde im Juli 1979 vom japanischen Konzern Sony auf den Markt gebracht. Der Walkman war die erste kostengünstige persönliche Stereoanlage der Welt. Der TPS-L2 wurde für rund 33'000 Yen (150 US-Dollar) verkauft. Sony rechnete mit etwa 5000 verkauften Einheiten pro Monat, bereits in den ersten zwei Monaten wurden aber mehr als 30'000 Stück verkauft."
                    source='Foto: Keystone'
                    appRef={appRef}
                  />{' '}
                  mobil wurde, waren Sie bereits {calculateAge(1979)} Jahre alt.
                  Irgendwann haben Sie zur CD gegriffen und schwören heute noch
                  darauf. Streaming, Downloads – das ist in Ihnen alles zu
                  mühsam. Oder haben Ihnen Ihre Kinder schon ein Spotify-Abo
                  geschenkt?
                </p>
              ),
            },
            {
              from: 1950,
              to: 1970,
              title: 'Sie gehören zur ersten Piraten-Generation',
              txt: (
                <p>
                  Radio an, Play- und Record-Taste drücken und los – Sie haben
                  sich hingesetzt und Ihre eigene Mix-Kassette hergestellt. Und
                  später hörten Sie Ihren Hitparaden-Mix unterwegs. Als 1979 der
                  erste{' '}
                  <ExplainMe
                    term='Walkman'
                    image={imageWalkman}
                    maxWidth={480}
                    caption="Der TPS-L2 war der erste portable Kassettenspieler und wurde im Juli 1979 vom japanischen Konzern Sony auf den Markt gebracht. Der Walkman war die erste kostengünstige persönliche Stereoanlage der Welt. Der TPS-L2 wurde für rund 33'000 Yen (150 US-Dollar) verkauft. Sony rechnete mit etwa 5000 verkauften Einheiten pro Monat, bereits in den ersten zwei Monaten wurden aber mehr als 30'000 Stück verkauft."
                    source='Foto: Keystone'
                    appRef={appRef}
                  />{' '}
                  in die Läden kam, waren Sie {calculateAge(1979)} Jahre alt.
                  Sie haben viel Geld für Vinyl ausgegeben und haben den
                  Aufstieg und Niedergang der CD miterlebt. Im Jahr 2000, als
                  der CD-Boom den Höhepunkt erreichte, waren Sie bereits{' '}
                  {calculateAge(2000)}-jährig – und haben vielleicht auch das
                  Album «Supernatural» von Santana gekauft, immerhin war es
                  damals 14 Wochen lang auf Platz eins der Hitparade. Maria,
                  Maria!
                </p>
              ),
            },
            {
              from: 1971,
              to: 1979,
              title: 'Mittendrin in der Musikrevolution',
              txt: (
                <>
                  <p>
                    Tragbare Radios waren bereits klitzeklein und Sie zarte{' '}
                    {calculateAge(1979)} Jahre alt, als 1979 der erste{' '}
                    <ExplainMe
                      term='Walkman'
                      image={imageWalkman}
                      maxWidth={480}
                      caption="Der TPS-L2 war der erste portable Kassettenspieler und wurde im Juli 1979 vom japanischen Konzern Sony auf den Markt gebracht. Der Walkman war die erste kostengünstige persönliche Stereoanlage der Welt. Der TPS-L2 wurde für rund 33'000 Yen (150 US-Dollar) verkauft. Sony rechnete mit etwa 5000 verkauften Einheiten pro Monat, bereits in den ersten zwei Monaten wurden aber mehr als 30'000 Stück verkauft."
                      source='Foto: Keystone'
                      appRef={appRef}
                    />{' '}
                    das Musikhören mobil machte. Sie haben vermutlich richtig
                    viel Geld ausgegeben: Für Walkman,{' '}
                    <ExplainMe
                      term='Discman'
                      image={imageDiscman}
                      maxWidth={480}
                      caption="Der erste Discman, der Sony D-50 (in manchen Regionen D-5), wurde im November 1984 auf den Markt gebracht – zwei Jahre nach Beginn der Massenproduktion von CDs. Die ersten Exemplare trugen noch nicht den Markennamen Discman, sondern wurden als «CD Compact Player» bezeichnet. Das Gerät wurde für 49'800 Yen (350 US-Dollar) verkauft."
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />
                    , MP3-Player, iPod – von den vielen CDs gar nicht zu
                    sprechen. Als der Rekordwert von 19,6 Millionen CDs in der
                    Schweiz im Jahr 2000 über den Ladentisch ging, waren Sie{' '}
                    {calculateAge(2000)} Jahre alt. In den folgenden Jahren
                    haben Sie wahrscheinlich MP3s gesammelt und möglichst clever
                    sortiert. Und seit es Musik-Streaming gibt, fragen Sie sich,
                    warum Sie sich diese Mühe gemacht haben.
                  </p>
                </>
              ),
            },
            {
              from: 1980,
              to: 1989,
              title: 'Mittendrin in der Musikrevolution',
              txt: (
                <>
                  <p>
                    {birthYear > 1980 ? birthYear - 1979 + ' Jahre' : 'Kurz'}{' '}
                    vor Ihrer Geburt machte 1979 der erste{' '}
                    <ExplainMe
                      term='Walkman'
                      image={imageWalkman}
                      maxWidth={480}
                      caption="Der TPS-L2 war der erste portable Kassettenspieler und wurde im Juli 1979 vom japanischen Konzern Sony auf den Markt gebracht. Der Walkman war die erste kostengünstige persönliche Stereoanlage der Welt. Der TPS-L2 wurde für rund 33'000 Yen (150 US-Dollar) verkauft. Sony rechnete mit etwa 5000 verkauften Einheiten pro Monat, bereits in den ersten zwei Monaten wurden aber mehr als 30'000 Stück verkauft."
                      source='Foto: Keystone'
                      appRef={appRef}
                    />{' '}
                    das Musikhören mobil. Nur wenig später folgte die Einführung
                    der CD (1982). Sie haben für Musik vermutlich richtig viel
                    Geld ausgegeben: Walkman,{' '}
                    <ExplainMe
                      term='Discman'
                      image={imageDiscman}
                      maxWidth={480}
                      caption="Der erste Discman, der Sony D-50 (in manchen Regionen D-5), wurde im November 1984 auf den Markt gebracht, zwei Jahre nach Beginn der Massenproduktion von CDs. Die ersten Exemplare trugen noch nicht den Markennamen Discman, sondern wurden als «CD Compact Player» bezeichnet. Das Gerät wurde für 49'800 Yen (350 US-Dollar) verkauft."
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />
                    , MP3-Player, iPod – von den vielen CDs gar nicht zu
                    sprechen. Als der Rekordwert von 19,6 Millionen CDs in der
                    Schweiz im Jahr 2000 über den Ladentisch ging, waren Sie{' '}
                    {calculateAge(2000)} Jahre alt. In den folgenden Jahren
                    haben Sie wahrscheinlich MP3s gesammelt und möglichst clever
                    sortiert. Und seit es Musik-Streaming gibt, fragen Sie sich,
                    warum Sie sich diese Mühe gemacht haben.
                  </p>
                </>
              ),
            },
            {
              from: 1990,
              to: 1999,
              title: 'Sie haben alles verpasst',
              txt: (
                <>
                  <p>
                    Die Erfindung des{' '}
                    <ExplainMe
                      term='Walkman'
                      image={imageWalkman}
                      maxWidth={480}
                      caption="Der TPS-L2 war der erste portable Kassettenspieler und wurde im Juli 1979 vom japanischen Konzern Sony auf den Markt gebracht. Der Walkman war die erste kostengünstige persönliche Stereoanlage der Welt. Der TPS-L2 wurde für rund 33'000 Yen (150 US-Dollar) verkauft. Sony rechnete mit etwa 5000 verkauften Einheiten pro Monat, bereits in den ersten zwei Monaten wurden aber mehr als 30'000 Stück verkauft."
                      source='Foto: Keystone'
                      appRef={appRef}
                    />{' '}
                    war vor Ihrer Zeit, ebenso die Einführung der CD (1982). Als
                    der CD-Boom im Jahr 2000 den Höhepunkt erreichte, waren Sie
                    erst {calculateAge(2000)}-jährig. Danach ging es mit der
                    silbrigen Scheibe bergab, ausgelöst durch die
                    Markteinführung des MP3-Players 1998. Da Sie ohnehin kaum
                    CDs besitzen oder Ihre Sammlung längst entsorgt haben, sind
                    Sie wahrscheinlich mit {calculateAge(2012)} auf ein
                    Smartphone umgestiegen und streamen Ihre Musik seither. Die
                    wunderbare Erfahrung eines Konzeptalbums mit minutenlangem
                    Intro werden Sie wohl nie mehr machen.
                  </p>
                </>
              ),
            },
            {
              from: 2000,
              to: 3000,
              title: 'Ja, Musik konnte man mal anfassen!',
              txt: (
                <>
                  <p>
                    Eine CD zu kaufen, käme Ihnen niemals in den Sinn. Seit Sie
                    auf der Welt sind, kennen die CD-Verkaufszahlen nur einen
                    Weg: nach unten. Zum Höhepunkt im Jahr 2000 waren Sie{' '}
                    {birthYear === 2000
                      ? 'gerade geboren'
                      : 'noch gar nicht auf der Welt'}
                    .{' '}
                    <ExplainMe
                      term='Walkman'
                      image={imageWalkman}
                      maxWidth={480}
                      caption="Der TPS-L2 war der erste portable Kassettenspieler und wurde im Juli 1979 vom japanischen Konzern Sony auf den Markt gebracht. Der Walkman war die erste kostengünstige persönliche Stereoanlage der Welt. Der TPS-L2 wurde für rund 33'000 Yen (150 US-Dollar) verkauft. Sony rechnete mit etwa 5000 verkauften Einheiten pro Monat, bereits in den ersten zwei Monaten wurden aber mehr als 30'000 Stück verkauft."
                      source='Foto: Keystone'
                      appRef={appRef}
                    />
                    ,{' '}
                    <ExplainMe
                      term='Discman'
                      image={imageDiscman}
                      maxWidth={480}
                      caption="Der erste Discman, der Sony D-50 (in manchen Regionen D-5), wurde im November 1984 auf den Markt gebracht, zwei Jahre nach Beginn der Massenproduktion von CDs. Die ersten Exemplare trugen noch nicht den Markennamen Discman, sondern wurden als «CD Compact Player» bezeichnet. Das Gerät wurde für 49'800 Yen (350 US-Dollar) verkauft."
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />
                    , MP3-Player – für Sie sind das historische Güter, die
                    allenfalls noch auf dem Dachboden Ihrer Eltern verstauben.
                    Kassetten kennen Sie höchstens noch von Kindermärchen, die
                    Ihre Eltern unverständlicherweise für Sie aufgehoben haben.
                  </p>
                </>
              ),
            },
          ],
        },
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/yikus/6/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'general',
          text: (
            <div>
              <StorageEvolution />
            </div>
          ),
        },
      ],
    },
    tv: {
      id: 'tv',
      title: 'Wie wir<br />fernsehen',
      titleMobile: 'Wie wir<br />fernsehen',
      video: videoTV,
      source: 'Videomaterial: SRF Archiv',
      license: '© 1970-2018 SRF, lizenziert durch Telepool GmbH Zürich',
      intro: (
        <p className='intro'>
          Das klassische Fernsehen bleibt trotz verschiedenster
          Streaming-Angebote beliebt. Vor allem bei den älteren Generationen hat
          der TV in der Stube seit Jahrzehnten seinen festen Platz. Im
          Durchschnitt schauen die Schweizerinnen und Schweizer heute 111
          Minuten pro Tag fern – ein Viertel weniger als noch vor 15 Jahren.
        </p>
      ),
      content: [
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '540px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/U5WEk/3/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'personalized',
          text: [
            {
              from: 0,
              to: 1957,
              title: 'Wow – Sie sind älter als das Fernsehen in der Schweiz',
              txt: (
                <>
                  <p>
                    Sie waren {calculateAge(1958)}{' '}
                    {birthYear < 1957 ? 'Jahre' : 'Jahr'} alt, als die SRG 1958
                    den regulären Sendebetrieb aufnahm. Vielleicht können Sie
                    sich noch an die erste Übertragung des Lauberhornrennens
                    zwei Jahre später erinnern. Sicher wissen Sie noch, dass das
                    Schweizer Fernsehen ab 1968 in Farbe zu sehen war. Damals
                    kostete ein Farb-TV-Gerät allerdings rund drei Monatslöhne,
                    nicht alle konnten sich eines leisten. Und so blieb das
                    Schwarzweissfernsehen noch für einige Jahre Standard.
                  </p>

                  <p>
                    Mit der Zeit wurden TV-Geräte immer günstiger und hielten in
                    fast jedem Haushalt Einzug. Dadurch haben Sie das goldene
                    Fernseh-Zeitalter miterlebt und gehören vielleicht zu den
                    Auserwählten, die am 20. Juli 1969 die erste Mondlandung
                    live im Schweizer Fernsehen verfolgten. Ihren Kindern haben
                    Sie erzählt, wie Sie die Erstausstrahlung von «Wetten,
                    dass..?», «sportpanorama» und anderen noch heute bekannten
                    Sendungen gesehen haben. Ihre Enkel können Sie damit kaum
                    beeindrucken. Diese schauen nur Youtube oder Netflix. Sie
                    aber halten dem klassischen Fernsehen bis heute die Treue.
                  </p>
                </>
              ),
            },
            {
              from: 1958,
              to: 1967,
              title: 'Wow – Sie haben noch das Schwarzweissfernsehen erlebt',
              txt: (
                <>
                  <p>
                    Sie waren {calculateAge(1968)}{' '}
                    {birthYear < 1967 ? 'Jahre' : 'Jahr'} alt, als das Schweizer
                    Fernsehen 1968 erstmals in Farbe ausgestrahlt wurde. Damals
                    kostete ein Farb-TV-Gerät allerdings rund drei Monatslöhne,
                    nicht alle konnten sich eines leisten. Und so blieb das
                    Schwarzweissfernsehen noch für einige Jahre Standard –
                    wahrscheinlich auch bei Ihnen zu Hause, wenn Ihre Eltern
                    glückliche Besitzer eines TV-Geräts waren.
                  </p>
                  <p>
                    Mit der Zeit wurden diese immer günstiger und hielten in
                    fast jedem Haushalt Einzug. Dadurch haben Sie das goldene
                    Fernseh-Zeitalter miterlebt und gehören vielleicht zu den
                    Auserwählten, die am 20. Juli 1969 die erste Mondlandung
                    live im Schweizer Fernsehen verfolgten. Ihren Kindern haben
                    Sie erzählt, wie Sie die Erstausstrahlung von «Wetten,
                    dass..?», «sportpanorama» und anderen noch heute bekannten
                    Sendungen gesehen haben. Ihre Enkel können Sie damit kaum
                    beeindrucken. Diese schauen Youtube oder Netflix. Sie
                    vielleicht auch. Trotzdem halten Sie dem klassischen
                    Fernsehen die Treue und schalten regelmässig für die
                    «Tagesschau» und verschiedene Sportevents ein.
                  </p>
                </>
              ),
            },
            {
              from: 1968,
              to: 1979,
              title: 'Sie haben Fernsehgeschichte miterlebt',
              txt: (
                <>
                  <p>
                    Sie waren zwar noch sehr jung oder noch gar nicht geboren,
                    als das Fernsehen sein goldenes Zeitalter feierte. So wurde
                    zumindest die Ära der amerikanischen Apollo-Missionen
                    (1968–1972) genannt. Am 20. Juli 1969 verfolgten mindestens
                    900’000 Schweizerinnen und Schweizer die erste Mondlandung
                    live im Fernsehen.
                  </p>
                  <p>
                    Dafür haben Sie viele andere, geschichtsträchtige Momente
                    und Entwicklungen des Fernsehens miterleben können:
                    Vielleicht die Erstausstrahlung von «Wetten, dass..?»,
                    «sportpanorama» und anderen noch heute bekannten Sendungen,
                    die Lancierung von Teletext, die Einführung und später den
                    Niedergang von{' '}
                    <ExplainMe
                      term='VHS'
                      image={imageVhs}
                      maxWidth={640}
                      caption='Die Abkürzung «VHS» steht für Video Home System und ermöglicht die analoge Aufzeichnung und Wiedergabe eines Fernsehsignals über Videokassetten. Lanciert wurde es 1976 von der Firma JVC in Japan. VHS setzte sich in den 80er-Jahren gegen die Konkurrenzformate Betamax und Video 2000 durch.'
                      source='Video: Gettyimages'
                      appRef={appRef}
                    />{' '}
                    und DVD oder das steigende Angebot von Privatsendern.
                    Vielleicht gehörten Sie auch zu den Pionieren, die ab 1984{' '}
                    <ExplainMe
                      term='Teleclub'
                      video={videoTeleclub}
                      maxWidth={480}
                      caption="Teleclub war Schweizer Pionier des Bezahlfernsehens. Von 1982 bis 1991 wurden für 28 Franken im Monat 180 Erstausstrahlungen von Kinofilmen jährlich geboten. Um das Signal zu entschlüsseln, musste ein Dekoder-Kästchen an den Fernseher angeschlossen werden. Bis 1985 hatte Teleclub in der Schweiz 40'000 Abonnenten."
                      source='Video: Teleclub Opener, ab 1987'
                      appRef={appRef}
                    />{' '}
                    abonnierten, einen der ersten Bezahlfernsehsender Europas.
                  </p>
                  <p>
                    Ihre Kinder können Sie mit solchen Geschichten allerdings
                    kaum beeindrucken. Diese schauen Youtube oder Netflix. Sie
                    vielleicht auch. Trotzdem halten Sie dem klassischen
                    Fernsehen die Treue und schalten regelmässig für die
                    «Tagesschau» und verschiedene Sportevents ein.
                  </p>
                </>
              ),
            },
            {
              from: 1980,
              to: 1993,
              title: 'Sie sind mit dem Fernsehen aufgewachsen',
              txt: (
                <>
                  <p>
                    Unter der Woche, als Sie in die Schule mussten, waren Sie
                    kaum aus dem Bett zu kriegen. Aber am Samstag und am Sonntag
                    stellten Sie Ihren Wecker extra früh, um noch vor dem
                    Aufwachen der Eltern möglichst viele Trickfilmserien
                    anzuschauen: «Tom und Jerry», «Ducktales», «Simpsons» und
                    viele weitere Klassiker standen auf dem Programm.
                  </p>
                  <p>
                    Vielleicht gehörten Sie sogar zu den Glücklichen, deren
                    Eltern ab 1984 ein{' '}
                    <ExplainMe
                      term='Teleclub-Abo'
                      video={videoTeleclub}
                      maxWidth={480}
                      caption="Teleclub war Schweizer Pionier des Bezahlfernsehens. Von 1982 bis 1991 wurden für 28 Franken im Monat 180 Erstausstrahlungen von Kinofilmen jährlich geboten. Um das Signal zu entschlüsseln, musste ein Dekoder-Kästchen an den Fernseher angeschlossen werden. Bis 1985 hatte Teleclub in der Schweiz 40'000 Abonnenten."
                      source='Video: Teleclub Opener, ab 1987'
                      appRef={appRef}
                    />{' '}
                    besassen und dank einem kleinen schwarzen Kästchen Kinofilme
                    vor allen anderen am Fernseher schauen konnten.
                  </p>
                  <p>
                    Später entdeckten Sie Musiksender wie MTV und Viva, waren
                    Zeuge der ersten Reality-TV-Formate wie «Big Brother» und
                    erlebten die Lancierung von immer mehr Privatsendern und
                    schliesslich des digitalen Fernsehangebots. Wahrscheinlich
                    haben Sie mal Zattoo, Wilma oder Teleboy ausprobiert.
                    Mittlerweile nutzen Sie aber Streaming-Angebote wie Netflix,
                    Amazon Prime oder Disney+. Klassisches Fernsehen konsumieren
                    Sie nur noch bei Live-Sport-Events.
                  </p>
                </>
              ),
            },
            {
              from: 1994,
              to: 1999,
              title:
                'Ja, früher musste man einen Film nach dem Schauen zurückspulen.',
              txt: (
                <>
                  <p>
                    Die Begriffe DVD und Blu-ray sind Ihnen wohl noch geläufig.
                    Bei{' '}
                    <ExplainMe
                      term='VHS'
                      image={imageVhs}
                      maxWidth={640}
                      caption='Die Abkürzung «VHS» steht für Video Home System und ermöglicht die analoge Aufzeichnung und Wiedergabe eines Fernsehsignals über Videokassetten. Lanciert wurde es 1976 von der Firma JVC in Japan. VHS setzte sich in den 80er-Jahren gegen die Konkurrenzformate Betamax und Video 2000 durch.'
                      source='Video: Gettyimages'
                      appRef={appRef}
                    />{' '}
                    wird es wahrscheinlich schon schwieriger. Sie sind mit dem
                    Internet aufgewachsen, und irgendwann ab 2005, als Youtube
                    startete, haben Sie begonnen online Videos zu schauen, statt
                    durch das dröge Fernsehprogramm zu zappen. Dieses
                    konsumierte man früher ausschliesslich auf grossen
                    stationären Geräten. Sie hingegen machen das heute unterwegs
                    auf Ihrem Handy. Das Streamen von Serien und Filmen auf
                    Netflix oder Disney+ gehört für Sie ebenso zum Alltag wie
                    Tutorials auf Youtube zu suchen. Sie können nicht verstehen,
                    warum Ihre Eltern immer noch jeden Abend dieselbe
                    langweilige «Tagesschau» einschalten.
                  </p>
                </>
              ),
            },
            {
              from: 2000,
              to: 3000,
              title: 'Ja, früher hat man auf grossen Geräten ferngesehen!',
              txt: (
                <>
                  <p>
                    <ExplainMe
                      term='VHS'
                      image={imageVhs}
                      maxWidth={640}
                      caption='Die Abkürzung «VHS» steht für Video Home System und ermöglicht die analoge Aufzeichnung und Wiedergabe eines Fernsehsignals über Videokassetten. Lanciert wurde es 1976 von der Firma JVC in Japan. VHS setzte sich in den 80er-Jahren gegen die Konkurrenzformate Betamax und Video 2000 durch.'
                      source='Video: Gettyimages'
                      appRef={appRef}
                    />
                    , DVD, Blu-ray – diese Begriffe sagen Ihnen wenig oder gar
                    nichts. Sie sind mit dem Internet aufgewachsen, und
                    spätestens seit 2005, als Youtube startete, schauen Sie
                    online Videos, statt durch das dröge Fernsehprogramm zu
                    zappen. Dieses konsumierte man früher ausschliesslich auf
                    grossen stationären Geräten. Sie hingegen machen das heute
                    unterwegs auf Ihrem Handy. Das Streamen von Serien und
                    Filmen auf Netflix oder Disney+ gehört für Sie ebenso zum
                    Alltag wie Tutorials auf Youtube zu suchen oder Livestreams
                    auf Twitch zu verfolgen. Sie können nicht verstehen, warum
                    Ihre Eltern immer noch jeden Abend dieselbe langweilige
                    «Tagesschau» einschalten.
                  </p>
                </>
              ),
            },
          ],
        },
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/BId2d/10/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'general',
          text: (
            <div>
              <p>
                Der Fernseher läuft in der Romandie und im Tessin deutlich
                häufiger als in der Deutschschweiz. Aber in allen Sprachregionen
                ist die TV-Nutzung in den letzten Jahren kontinuierlich
                zurückgegangen – trotz Streaming, das seit 2013 mitgezählt wird.
                2009 schauten die Schweizerinnen und Schweizer durchschnittlich
                148 Minuten pro Tag fern, 2022 waren es nur noch 111 Minuten –
                ein Viertel weniger.
              </p>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/rTb0q/6/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
      ],
    },
    socialmedia: {
      id: 'socialmedia',
      title: 'Wie wir unser<br />Sozialleben gestalten',
      titleMobile: 'Wie wir unser Sozialleben gestalten',
      video: videoSocialmedia,
      source: 'Videomaterial: SRF Archiv',
      license: '© 1970-2018 SRF, lizenziert durch Telepool GmbH Zürich',
      intro: (
        <p className='intro'>
          Die Macht sozialer Netzwerke dürfte inzwischen allen bewusst sein.
          Bemerkenswert ist vor allem, wie rasend die Entwicklung war.
        </p>
      ),
      content: [
        {
          type: 'general',
          text: (
            <div>
              <AutofitIFrame
                style={{ width: '100%', height: '520px', marginTop: '2rem' }}
                src={
                  'https://datawrapper.dwcdn.net/JLQ7Y/14/?dark=true&transparent=true'
                }
              />
            </div>
          ),
        },
        {
          type: 'personalized',
          text: [
            {
              from: 0,
              to: 1944,
              title: 'Was soll daran sozial sein?',
              txt: (
                <>
                  <p>
                    Gratulation, Sie gehören zur Generation, die sich mit den
                    Freunden noch persönlich unterhalten hat. Ihr soziales
                    Netzwerk traf sich in der Beiz oder bei jemandem zu Hause.
                    Wollten Sie mit Ihren Ferienfotos prahlen, haben Sie zum
                    Dia-Abend eingeladen.
                  </p>
                  <p>
                    Als Facebook gegründet wurde und das Leben Ihrer Kinder und
                    Enkel veränderte, waren Sie bereits {calculateAge(2004)}
                    -jährig. Vermutlich haben Sie aber dennoch irgendwann auch
                    ein Konto angelegt. Heute dominiert Facebook die sozialen
                    Netzwerke mit 3 Milliarden monatlich aktiven Nutzerinnen und
                    Nutzern weltweit. Allerdings verliert die Jugend das
                    Interesse daran: Wie die{' '}
                    <Stink href='https://www.zhaw.ch/storage/psychologie/upload/forschung/medienpsychologie/james/2018/Bericht_JAMES_2022_de.pdf'>
                      James-Studie-2022
                    </Stink>{' '}
                    zeigt, nutzen gerade noch 5 Prozent der 12- bis 19-Jährigen
                    Facebook mehrmals pro Woche.
                  </p>
                  <p>
                    Heute dominieren bei den Jungen die Plattformen Instagram,
                    Snapchat oder Tiktok. Auf diesen Zug sprangen Sie selbst
                    allerdings nicht mehr auf. Und wahrscheinlich finden Sie es
                    befremdlich, dass die Nutzung sozialer Netzwerke zu den
                    häufigsten Freizeitaktivitäten der Jugendlichen gehört: 90
                    Prozent von ihnen besuchen diese täglich oder mehrmals pro
                    Woche.
                  </p>
                </>
              ),
            },
            {
              from: 1945,
              to: 1960,
              title: 'Was soll daran sozial sein?',
              txt: (
                <>
                  <p>
                    Gratulation, Sie gehören zur Generation, die sich mit den
                    Freunden noch persönlich unterhalten hat. Ihr soziales
                    Netzwerk traf sich in der Beiz oder bei jemandem zu Hause.
                    Wollten Sie mit Ihren Ferienfotos prahlen, haben Sie zum
                    Dia-Abend eingeladen.
                  </p>
                  <p>
                    Als Facebook gegründet wurde und das Leben Ihrer Kinder und
                    Enkel veränderte, waren Sie bereits {calculateAge(2004)}
                    -jährig. Vermutlich haben Sie aber dennoch irgendwann auch
                    ein Konto angelegt. Heute dominiert Facebook die sozialen
                    Netzwerke mit 3 Milliarden monatlich aktiven Nutzerinnen und
                    Nutzern weltweit. Allerdings verliert die Jugend das
                    Interesse daran: Wie die{' '}
                    <Stink href='https://www.zhaw.ch/storage/psychologie/upload/forschung/medienpsychologie/james/2018/Bericht_JAMES_2022_de.pdf'>
                      James-Studie-2022
                    </Stink>{' '}
                    zeigt, nutzen gerade noch 5 Prozent der 12- bis 19-Jährigen
                    Facebook mehrmals pro Woche.
                  </p>
                  <p>
                    Heute dominieren bei den Jungen die Plattformen Instagram,
                    Tiktok oder Snapchat. Selbst haben Sie sich schon lange
                    vorgenommen, dieses Instagram mal auszuprobieren.
                    Bemerkenswert ist, dass die Nutzung sozialer Netzwerke zu
                    den häufigsten Freizeitaktivitäten der Jugendlichen gehört:
                    90 Prozent von ihnen besuchen diese täglich oder mehrmals
                    pro Woche. Auch Sie selbst nutzen Whatsapp regelmässig und
                    verschicken hin und wieder auch mal ein lustiges Filmchen
                    oder Bild, das Sie von Freunden bekommen haben.
                  </p>
                </>
              ),
            },
            {
              from: 1961,
              to: 1973,
              title: 'Nein, Snapchat und Tiktok sind keine Zeichentrickfiguren',
              txt: (
                <>
                  <p>
                    Sie waren bereits {calculateAge(2004)}-jährig, als Facebook
                    2004 gegründet wurde. Trotzdem gehören Sie sicherlich auch
                    zu den 3 Milliarden Nutzerinnen und Nutzern weltweit.
                    Allerdings verliert die Jugend das Interesse daran: Wie die{' '}
                    <Stink href='https://www.zhaw.ch/storage/psychologie/upload/forschung/medienpsychologie/james/2018/Bericht_JAMES_2022_de.pdf'>
                      James-Studie-2022
                    </Stink>{' '}
                    zeigt, nutzen gerade noch 5 Prozent der 12- bis 19-Jährigen
                    Facebook mehrmals pro Woche.
                  </p>
                  <p>
                    Heute dominieren bei den Jungen die Plattformen Instagram,
                    Tiktok oder Snapchat. Auf diesen Zug sprangen Sie selbst
                    allerdings nicht mehr auf. Vielleicht haben Sie mal ein
                    Instagram-Konto angelegt und nehmen sich vergebens vor,
                    endlich mal wieder etwas darauf zu posten. Sie verstehen
                    zwar, dass Whatsapp praktischer ist als SMS, warum die
                    Jungen aber nicht mal mehr tippen oder telefonieren, sondern
                    nur noch Sprachnachrichten verschicken, bringt Sie ins
                    Grübeln.
                  </p>
                </>
              ),
            },
            {
              from: 1972,
              to: 1990,
              title: 'Haben Sie Ihren Facebook-Account noch?',
              txt: (
                <>
                  <p>
                    Die Frage ist kaum, ob Sie einen Facebook-Account haben,
                    sondern, ob sie ihn noch immer nutzen: Sie waren{' '}
                    {calculateAge(2004)}-jährig, als die Plattform 2004
                    gegründet wurde – und Sie sind früher oder später auf den
                    Zug aufgesprungen. Inzwischen fragen Sie sich aber, ob es
                    der richtige Entscheid war. Nicht nur haben Sie all die
                    Skandale verunsichert, Facebook ist inzwischen auch ganz
                    schön langweilig geworden. Aber das geht nicht nur Ihnen so.
                    Die Jugend hat schon länger das Interesse daran verloren:
                    Wie die{' '}
                    <Stink href='https://www.zhaw.ch/storage/psychologie/upload/forschung/medienpsychologie/james/2018/Bericht_JAMES_2022_de.pdf'>
                      James-Studie-2022
                    </Stink>{' '}
                    zeigt, nutzen gerade noch 5 Prozent der 12- bis 19-Jährigen
                    Facebook mehrmals pro Woche.
                  </p>
                  <p>
                    Heute dominieren bei den Jungen die Plattformen Instagram,
                    Tiktok oder Snapchat. Auf Instagram haben Sie natürlich auch
                    nicht verzichtet, irgendwo muss man ja die schönen
                    Ferienfotos posten – pics or it didn’t happen! Mit Snapchat
                    und Tiktok befassen Sie sich aber nicht mehr, jeden Quatsch
                    muss man nicht mitmachen. Vielleicht überlegen Sie aber
                    gerade, ob Sie von Twitter/X zu Bluesky wechseln sollten.
                  </p>
                </>
              ),
            },
            {
              from: 1991,
              to: 3000,
              title: 'Facebook, was?',
              txt: (
                <>
                  <p>
                    Wow, Sie waren{' '}
                    {birthYear > 2004
                      ? 'noch nicht mal geboren'
                      : 'noch ein Kind'}
                    , als Facebook 2004 gegründet wurde und die Welt der
                    Erwachsenen veränderte. Vielleicht haben Sie es selbst
                    ausprobiert. Je jünger Sie sind, desto unwahrscheinlicher
                    ist das allerdings. Ihre Plattformen sind eher Instagram,
                    Tiktok oder Snapchat. Und: Wissen Sie eigentlich, wie vielen
                    Whatsapp-Gruppen Sie angehören? Viel Spass beim Zählen! Oder
                    gehören Sie gar zu den besonders Gewieften, die Google Docs
                    für Chats nutzen?
                  </p>
                  <p>
                    Übrigens: Vor Facebook hiessen die sozialen Medien{' '}
                    <ExplainMe
                      term='Myspace'
                      image={imageMyspace}
                      maxWidth={640}
                      caption='Myspace wurde im August 2003 gestartet und war das erste soziale Netzwerk, das ein globales Publikum erreichte. Von 2005 bis 2009 war Myspace das grösste Social-Network der Welt. Im Juni 2006 überholte es Yahoo! und Google und wurde zur meistbesuchten Website in den USA. Im Geschäftsjahr 2008 erwirtschaftete es 800 Millionen Dollar Umsatz.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />
                    ,{' '}
                    <ExplainMe
                      term='StudiVZ'
                      image={imageStudivz}
                      maxWidth={640}
                      caption='StudiVZ (kurz für Studiverzeichnis) war ein soziales Netzwerk für Studenten und wurde 2005 gegründet. Bis 2009 wurde StudiVZ in verschiedenen Sprachen mit separaten Plattformen angeboten, nachher konzentrierte sich das Netzwerk ausschliesslich auf den deutschsprachigen Raum. Der Eigentümer, Poolworks, meldete am 7. September 2017 Insolvenz an. Erst 2022 wurde die Plattform aber endgültig abgeschaltet.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />{' '}
                    und{' '}
                    <ExplainMe
                      term='ICQ'
                      image={imageIcq}
                      audio={audioIcq}
                      position={'top'}
                      maxWidth={320}
                      caption='ICQ war eine der ersten Instant-Messenger-Anwendungen. Zwar war der Echtzeit-Chat an sich nicht neu (Internet Relay Chats existieren seit 1988), legte mit seinem Konzept von individuellen Benutzerkonten, die sich auf Einzelgespräche konzentrierten, aber den Grundstein für spätere Instant-Messaging-Dienste. Auf seinem Höhepunkt um 2001 hatte ICQ mehr als 100 Millionen registrierte Konten.'
                      source='Quelle: Wikipedia'
                      appRef={appRef}
                    />
                    . Aber glauben Sie uns, irgendwann werden auch «Ihre
                    Plattformen» verschwunden sein. Die Chat-Plattform ICQ ging
                    1996 an den Start und benötigte vier Jahre, um 100 Millionen
                    Nutzer(innen) zu erreichen. Myspace, gegründet 2005, gelang
                    dies bereits innerhalb eines Jahres. Fünf Jahre später
                    brachen die Nutzerzahlen bereits um 70 Prozent ein. Beide
                    Plattformen sind heute kein Thema mehr.
                  </p>
                </>
              ),
            },
          ],
        },
      ],
    },
  }
}
